import { render, staticRenderFns } from "./loading-box.vue?vue&type=template&id=0e274a46&scoped=true"
import script from "./loading-box.vue?vue&type=script&lang=js"
export * from "./loading-box.vue?vue&type=script&lang=js"
import style0 from "./loading-box.vue?vue&type=style&index=0&id=0e274a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e274a46",
  null
  
)

export default component.exports